// Helpers de cor em hex, encadeáveis (lighten(darken(...))) — usados pra
// derivar gradientes de uma cor-base vinda do core (ex.: fatias da roletinha).
// Candidatos a absorver as cópias locais de hexToRgb/darkenHex espalhadas em
// components/casino/* quando o Design System (ENG-342) migrar as cores.

export function parseHex(hex: string): [number, number, number] | null {
  const n = parseInt(hex.replace('#', ''), 16);

  if (Number.isNaN(n)) return null;

  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}

export function toHex(r: number, g: number, b: number): string {
  const clamp = (c: number) => Math.max(0, Math.min(255, Math.round(c)));

  return `#${[r, g, b].map((c) => clamp(c).toString(16).padStart(2, '0')).join('')}`;
}

// Clareia um hex misturando com branco por um fator (0..1). Valor não-hex
// passa direto (sem conversão possível).
export function lighten(hex: string, factor: number): string {
  const rgb = parseHex(hex);

  if (!rgb) return hex;

  const [r, g, b] = rgb;

  return toHex(
    r + (255 - r) * factor,
    g + (255 - g) * factor,
    b + (255 - b) * factor,
  );
}

// Escurece um hex multiplicando os canais por (1 - fator), preservando o matiz.
export function darken(hex: string, factor: number): string {
  const rgb = parseHex(hex);

  if (!rgb) return hex;

  const [r, g, b] = rgb;

  return toHex(r * (1 - factor), g * (1 - factor), b * (1 - factor));
}
